var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dummy-chart"},[_c('v-chart',{staticStyle:{"width":"600px","height":"600px","background-color":"#0aa0ff"},attrs:{"options":_vm.chartOptions}}),_c('line-chart',{attrs:{"data-option":_vm.chartOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }